// extracted by mini-css-extract-plugin
export var label = "_d1-1";
export var reminder = "_d1-0";